__turbopack_context__.v({
  "modalContent": "cookiesModal-module-scss-module__zilx8q__modalContent",
  "modalContentLeftText": "cookiesModal-module-scss-module__zilx8q__modalContentLeftText",
  "modalContentLeftTitle": "cookiesModal-module-scss-module__zilx8q__modalContentLeftTitle",
  "modalContentRight": "cookiesModal-module-scss-module__zilx8q__modalContentRight",
});
